<h1 class="center-text">Reports</h1>
<br />
@if (!haveReports || !reportList || reportList.length == 0)
{
  <div class="empty_spacing_for_norecords">
    @if(gettingReports){
      <div>
        <app-lt-spinner></app-lt-spinner>
      </div>
    }
    @else if(!reportList)
    {
      <div class="no-records-message">No records found.</div>
    }
  </div>
}
@else
{
  <div class="row row-cols-1 row-cols-lg-2">
    @for (r of reportList; track r.reportId) {
      @if (canSelectReport(r))
      {
        <div class="col mb-4" (click)="selectReport(r)" (keydown.enter)="selectReport(r)">
          <div class="card">
            <div class="card-header bg-secondary text-white">{{r.title}}</div>
            <div class="card-body w-75">{{r.description}}</div>
          </div>
        </div>
      }
    }
  </div>
}